import type { DiscoverySession } from '@/entities/discovery';
import { DiscoveryChatPanel } from './discovery-chat-panel';
import { DiscoveryResultsPanel } from './discovery-results-panel';
import { useDiscoveryPanelWidth } from '../hooks';
import { cn } from '@/shared/utils';
import { useRef } from 'react';

export const DiscoverySearchContainer = ({ session }: { session: DiscoverySession }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleResizeStart, width } = useDiscoveryPanelWidth();
  const sessionId = session.session_id;
  const searchId = session.current_search_history_id;

  return (
    <div className="h-screen overflow-hidden" ref={containerRef}>
      <div
        className="grid h-full transition-all duration-200"
        style={{
          gridTemplateColumns: searchId
            ? `${width}px 1fr`
            : `${containerRef.current?.getBoundingClientRect().width}px 1fr`,
        }}
      >
        <DiscoveryChatPanel session={session} />
        <div
          className={cn(
            'group absolute z-10 flex h-full w-5 justify-center hover:cursor-ew-resize',
            !searchId && 'hidden',
          )}
          style={{ transform: `translateX(${width - 10}px)` }}
          onMouseDown={handleResizeStart}
        >
          <div className="w-px bg-gray-200 transition-all group-hover:bg-gray-400"></div>
        </div>

        <main className="flex h-screen min-w-0 flex-1 flex-col overflow-x-auto">
          <DiscoveryResultsPanel
            key={`${sessionId}:${searchId ?? 'none'}`}
            sessionId={sessionId}
            searchId={searchId}
          />
        </main>
      </div>
    </div>
  );
};
